<template>
  <div :class="$style.qrcode">
    <span :class="$style.trigger" @click="toggleQrcode"></span>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="false"
      :append-to-body="true"
      custom-class="qrcodeDialog"
      :class="$style.dialog"
    >
      <div :class="$style.qr">
        <canvas id="qrcode"></canvas>
      </div>
      <p :class="$style.desc">{{ $t("060897215f") }}</p>
      <p :class="$style.tips">{{ $t("d488af2c8e") }}</p>
    </el-dialog>
  </div>
</template>
<script>
import qrcode from 'qrcode'
export default {
  name: 'QRCode',
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    toggleQrcode() {
      this.dialogVisible = true
      this.$nextTick(() => {
        qrcode.toCanvas(
          document.getElementById('qrcode'),
          location.origin + location.pathname,
          {
            width: 136,
            height: 136,
            margin: 0
          },
          function (err) {
            if (err) console.error(err)
            console.log('success!')
          }
        )
      })
    }
  }
}
</script>
<style lang="scss" module>
$size: 30px;

.qrcode {
  display: inline-block;
  width: $size;
  height: $size;
}

.trigger {
  display: inline-block;
  width: $size;
  height: $size;
  background: url(./assets/qrcode_icon.svg) no-repeat 50% #fff;
  background-size: 24px;
  border: 1px solid #e2e2e2;
  box-sizing: border-box;
}

.qr {
  margin-bottom: 12px;
}

.desc {
  margin: 0;
  color: #383838;
  line-height: 20px;
}

.tips {
  margin: 0;
  color: #969696;
  line-height: 20px;
}

:global {
  body {
    .qrcodeDialog {
      position: absolute;
      left: auto;
      transform: none;
      right: 52px;
      top: 42px !important;
      margin: 0 !important;
      width: 184px !important;
      height: 232px;
      &.el-dialog {
        padding: 0;
      }

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        padding: 20px 14px !important;
        text-align: center;
      }
    }
    .topBar .left .qrcodeDialog {
      left: 52px;
    }
  }
}
</style>
